var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.206,
    height: 16.257,
    viewBox: "0 0 13.206 16.257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39302",
    "data-name": "Path 39302",
    d: "M15.092,11.568,9.419,6.277a.19.19,0,0,0-.255,0L3.491,11.568a.16.16,0,0,0,0,.237l.241.224a.19.19,0,0,0,.255,0L8.819,7.523a.073.073,0,0,1,.123.047v13.2a.174.174,0,0,0,.18.168h.34a.174.174,0,0,0,.18-.168V7.571a.073.073,0,0,1,.123-.047L14.6,12.03a.19.19,0,0,0,.255,0l.241-.224a.16.16,0,0,0,0-.237",
    transform: "translate(-2.689 -5.431)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTop);
export default __webpack_public_path__ + "static/media/icon_top.c9f8238e824344ccf8d5cd7e002136e1.svg";
export { ForwardRef as ReactComponent };